/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
// import { Button, Grid, Typography } from "@material-ui/core";
import * as Yup from "yup";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

// Inputs
import { FormItem } from "react-material-formik-wizard";

import { getSingleUser } from "actions/userActions";

// const AboutSchema = Yup.object().shape({
//   country: Yup.string()
//     .trim()
//     .notOneOf([""], "Please select an option")
//     .required("Required"),
//   sauce_type: Yup.string()
//     .trim()
//     .notOneOf([""], "Please select an option")
//     .required("Required"),
//   description: Yup.string()
//     .trim()
//     .min(3, "Too Short!")
//     .max(70, "Too Long!")
//     .required("Required"),
//   taste_profile: Yup.array()
//     .of(Yup.string().required("Need to choose at least 1"))
//     .required("Required"),
// });

const PersonalDetailsStep = (props) => {
  const dispatch = useDispatch();
  const { next, back, values } = props;
  // const [countries, setCountries] = useState([]);

  const singleUser = useSelector((state) => state.singleUser);
  const { userSingle } = singleUser;

  useEffect(() => {
    dispatch(getSingleUser());
  }, [dispatch, userSingle?.length]);

  // useEffect(() => {
  //   const getCountries = async () => {
  //     let countriesString = sessionStorage.getItem("countries");
  //     // if countriesString is null or it has an item with empty string value
  //     if (
  //       countriesString === null ||
  //       JSON.parse(countriesString)[0].value === ""
  //     ) {
  //       await fetch("https://restcountries.eu/rest/v2/all")
  //         .then((response) => response.json())
  //         .then((data) => {
  //           const countryArray = [];
  //           data.map((country) => {
  //             return countryArray.push({
  //               label: country.name,
  //               value: country.name,
  //             });
  //           });
  //           sessionStorage.setItem("countries", JSON.stringify(countryArray));
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //           let connErr = [
  //             { label: "Connection issue, wait and refresh", value: "" },
  //           ];
  //           return sessionStorage.setItem("countries", JSON.stringify(connErr));
  //         });
  //     }
  //     return setCountries(JSON.parse(sessionStorage.getItem("countries")));
  //   };

  //   const mapValues = () => {
  //     values.country = values.country ? values.country : "";
  //     values.sauce_type = values.sauce_type ? values.sauce_type : "";
  //     values.description = values.description ? values.description : "";
  //     values.taste_profile = values.taste_profile ? values.taste_profile : [];
  //   };

  //   getCountries();
  //   mapValues();
  // }, []);

  return (
    <React.Fragment>
      <Formik
        enableReinitialize={true}
        initialValues={[]}
        // validationSchema={AboutSchema}
        onSubmit={(values) => {
          next({ values });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          validateField,
          setFieldValue,
          setFieldTouched,
        }) => (
          <>
            <form onSubmit={handleSubmit}>
              <MKBox display="flex" width="100%" height="100%">
                <MKBox py={6} pr={6} pl={{ xs: 6, sm: 12 }} my="auto">
                  <MKTypography variant="h4" mb={1}>
                    Contact Information
                  </MKTypography>
                  <MKBox display="flex" p={1}>
                    <MKTypography variant="button">
                      <i className="fas fa-user" />
                    </MKTypography>
                    <MKTypography
                      variant="body"
                      fontSize="medium"
                      opacity={0.8}
                      pl={2}
                      fontWeight="regular"
                    >
                      {userSingle?.name}
                    </MKTypography>
                  </MKBox>
                  <MKBox display="flex" p={1}>
                    <MKTypography variant="button">
                      <i className="fas fa-phone" />
                    </MKTypography>
                    <MKTypography
                      variant="body"
                      fontSize="medium"
                      opacity={0.8}
                      pl={2}
                      fontWeight="regular"
                    >
                      {userSingle?.phone}
                    </MKTypography>
                  </MKBox>
                  <MKBox display="flex" p={1}>
                    <MKTypography variant="button">
                      <i className="fas fa-envelope" />
                    </MKTypography>
                    <MKTypography
                      variant="body"
                      fontSize="medium"
                      opacity={0.8}
                      pl={2}
                      fontWeight="regular"
                    >
                      {userSingle?.email}
                    </MKTypography>
                  </MKBox>
                  <MKBox display="flex" p={1}>
                    <MKTypography variant="button">
                      <i className="fas fa-map-marker-alt" />
                    </MKTypography>
                    <MKTypography
                      variant="body"
                      fontSize="medium"
                      opacity={0.8}
                      pl={2}
                      fontWeight="regular"
                    ></MKTypography>
                  </MKBox>
                </MKBox>
              </MKBox>
              <Grid
                container
                spacing={0}
                direction="row"
                justify="space-between"
              >
                <Grid item md={1} lg={1}>
                  <MKButton
                    disabled={isSubmitting}
                    onClick={(e) => back(e, values)}
                  >
                    Back
                  </MKButton>
                </Grid>
                <Grid item md={10} lg={10} />
                <Grid item md={1} lg={1}>
                  <MKButton
                    disabled={isSubmitting || Object.entries(errors).length > 0}
                    type="submit"
                  >
                    Next
                  </MKButton>
                </Grid>
              </Grid>
            </form>
          </>
        )}
      </Formik>
    </React.Fragment>
  );
};
export default PersonalDetailsStep;
